// extracted by mini-css-extract-plugin
export default {"inputWrapper":"inputWrapper__Mh0-b"};